// extracted by mini-css-extract-plugin
module.exports = {"link":"InstallationCostTooltip_link__z9xxK"};